import React, { useEffect } from 'react';
import { 
  useShowInsufficientBalance,
  useOpenBuyInModal,
  useOpenRebuyInModal,
  useGameDefinition
} from '@/src/hooks/data/useGameTable';
import InsufficientBalanceDrawer from '../InsufficientBalance/InsufficientBalanceDrawer';
// import BuyIn from '../BuyIn/BuyIn';
import { BuyIn } from '@themed-components';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import { hideInsufficientBalance } from '@/Poker/redux/slices/gameTableSlice';
import { useDispatch } from 'react-redux';

export default function BuyInDrawer({ tempTableId }) {
    const showInsufficientBalance = useShowInsufficientBalance(tempTableId);
    const openBuyInModal = useOpenBuyInModal(tempTableId);
    const openRebuyInModal = useOpenRebuyInModal(tempTableId);
    const gameDefinition = useGameDefinition(tempTableId);
    const minBuyInAmount = gameDefinition?.minBuyInAmount;
    const { totalBalance } = usePlayerBalance();
    const dispatch = useDispatch();

    useEffect(() => {
        if (totalBalance >= minBuyInAmount) {
            dispatch(hideInsufficientBalance({ tempTableId }));
        }
    }, [totalBalance])

    if (!tempTableId) {
        console.warn('Temp Table ID is missing in Game Table Buy In Drawer ');
        return null;
    }

    return (
        <>
            <InsufficientBalanceDrawer
                tempTableId={tempTableId}
                showInsufficientBalance={showInsufficientBalance}
            />
            {
                !showInsufficientBalance && (
                    <BuyIn tempTableId={tempTableId} />
                )
            }
        </>
    );
}
